const union = [{
  desc: '登录接口',
  options: {
    url: '/union/unionLogin',
    method: 'post'
  }
}, {
  desc: '联合登录加密接口',
  options: {
    url: '/union/unionLoginEncryptionPortal',
    method: 'post'
  }
}, {
  desc: '检查短信是否是正确的',
  options: {
    url: '/union/checkUnionLoginByMessage',
    method: 'post',
    formdata: true,
    needCustomMessage: true // 是否需要自定义错误提示信息显示
  }
}, {
  desc: '免登陆接口',
  options: {
    url: '/union/nonLogin',
    method: 'get',
    argsParams: true
  }
}]
export default union



// WEBPACK FOOTER //
// ./src/api/union.js